import(/* webpackMode: "eager" */ "/app/src/app/(mainWebsite)/develocity/(pillarPages)/layout.tsx");
